// src/AdminAchievements.js
import React, { useEffect, useState } from 'react';
// import axios from 'axios';
import axios from "./axiosConfig"; // adjust path if needed
import './AdminAchievements.css';
import { useNavigate } from 'react-router-dom';

function AdminAchievements() {
  const [adoptedAnimals, setAdoptedAnimals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    if (!user?.id) return;

    // axios.get(`http://localhost:8080/api/animals/adopted?requesterId=${user.id}`)
    axios.get(`/api/animals/adopted?requesterId=${user.id}`)
      .then(res => setAdoptedAnimals(res.data))
      .catch(() => setMessage('Failed to load adopted animals. Admin only.'))
      .finally(() => setLoading(false));
  }, [user]);

  return (
    <div className="achievements-container">
      <h2>🏆 Adopted Animals</h2>
      <button className="back-button" onClick={() => navigate('/dashboard')}>
        ← Back to Dashboard
      </button>

      {loading && <p>Loading...</p>}
      {message && <p className="error">{message}</p>}

      <div className="adopted-list">
        {adoptedAnimals.length === 0 ? (
          <p>No animals have been marked as adopted yet.</p>
        ) : (
          adoptedAnimals.map(animal => (
            <div key={animal.id} className="adopted-card">
              <img src={animal.imageUrl} alt={animal.name} />
              <h3>{animal.name}</h3>
              <p><strong>Type:</strong> {animal.type}</p>
              <p><strong>Breed:</strong> {animal.breed}</p>
              <p><strong>Posted By:</strong> {animal.createdBy?.name}</p>
              <p><strong>Location:</strong> {animal.location}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default AdminAchievements;
